import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

/**
 * One flat sidebar nav entry. Rich/nested entries (collapsible submenus, usage
 * meters) are NOT modelled here — surfaces render those as their own children
 * inside the SidebarFrame. SidebarNav only covers the common flat link case.
 */
export interface SidebarNavItem {
  icon: ReactNode;
  label: string;
  to: string;
  isActive?: boolean;
  tooltip?: string;
}

/**
 * Renders a list of flat nav items as full-width sidebar links
 * (`rounded-none px-4`, matching the channel list rows + group label so every
 * item shares one 16px left edge). Returns a fragment of SidebarMenuItems —
 * drop it inside a <SidebarMenu>.
 */
export function SidebarNav({ items }: { items: SidebarNavItem[] }) {
  return (
    <>
      {items.map((item) => (
        <SidebarMenuItem key={`${item.to}:${item.label}`}>
          <SidebarMenuButton
            render={<Link to={item.to} />}
            isActive={item.isActive}
            className="rounded-none px-4"
            tooltip={item.tooltip ?? item.label}
          >
            {item.icon}
            <span>{item.label}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </>
  );
}
